/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getInstrumentLink} from '../api'

 export const useQueryGetInstrumentLink = createReactQueryHook('getInstrumentLink', getInstrumentLink)
